export default __webpack_public_path__ + "stickup_cam_mini_v3.d6116afa.png";